export default {
  getSales(state) {
    return state.sales;
  }
}
